import React from 'react';
import { Link } from 'react-router-dom';

const values = [
  { icon: '🌿', title: 'Sürdürülebilirlik', desc: 'FSC sertifikalı ormanlardan tedarik ettiğimiz ahşap ve sıfır atık üretim anlayışıyla doğaya saygı gösteriyoruz.' },
  { icon: '🏆', title: 'Kalite Odaklılık', desc: 'ISO 9001 belgemiz ve CE sertifikalarımızla her ürünümüzde uluslararası kalite standartlarını sağlıyoruz.' },
  { icon: '🤝', title: 'Güven & Şeffaflık', desc: 'Müşterilerimizle uzun soluklu ilişkiler kuruyoruz. Her projede dürüstlük ve şeffaflık temel ilkemizdir.' },
  { icon: '💡', title: 'İnovasyon', desc: 'Geleneksel ahşap ustalığını modern CNC teknolojisiyle birleştirerek sektörde öncü olmayı sürdürüyoruz.' },
  { icon: '🎯', title: 'Müşteri Odaklılık', desc: 'Her müşterimizin ihtiyacına özel çözümler üretiyoruz. Projeleriniz baştan sona bizim sorumluluğumuzda.' },
  { icon: '🌍', title: 'Global Vizyon', desc: '10+ ülkeye ihracat gerçekleştiren global bir marka olarak dünya standartlarında üretim yapıyoruz.' },
];


export default function Hakkimizda() {
  return (
    <>
      {/* PAGE HERO */}
      <div className="page-hero">
        <div className="page-hero-content">
          <div className="page-hero-tag">Biz Kimiz</div>
          <h1>Ormandan Evinize,<br /><em>15 Yıllık Ustalık</em></h1>
        </div>
      </div>

      {/* HİKAYEMİZ */}
      <section className="section">
        <div className="about-page-grid">
          <div>
            <div className="section-tag">Hikayemiz</div>
            <div className="section-title" style={{fontSize:'36px'}}>2010'dan Bu Yana<br />Ahşabın Ustası</div>
            <p style={{color:'var(--text-muted)', fontSize:'15px', lineHeight:'1.9', marginTop:'20px'}}>
              Element Global, 2010 yılında küçük bir atölye olarak başladığı yolculuğunda bugün Türkiye'nin
              en köklü ahşap işleme firmalarından biri haline gelmiştir. Kurucumuz Özgür Yıldırım'ın ahşaba
              duyduğu tutkudan doğan bu marka, yıllar içinde büyüyerek dev bir
              aileye dönüşmüştür.
            </p>
            <p style={{color:'var(--text-muted)', fontSize:'15px', lineHeight:'1.9', marginTop:'16px'}}>
              Bugün Antalya'daki 6000 m² kapalı üretim alanımızda, ham keresteden nihai ürüne kadar
              tüm süreçleri kendi bünyemizde gerçekleştiriyoruz. Her yıl 100'lerce projeyi
              başarıyla tamamlıyor, 10'u aşkın ülkeye ürün ihraç ediyoruz.
            </p>
            <div style={{marginTop:'40px', display:'flex', gap:'16px', flexWrap:'wrap'}}>
              <Link to="/iletisim" className="btn-dark">Bizimle Çalışın</Link>
              <Link to="/hizmetler" className="btn-all">Hizmetlerimiz →</Link>
            </div>
          </div>
          <div>
            <div style={{
              width:'100%', aspectRatio:'4/3',
              background:'linear-gradient(135deg, var(--wood-dark) 0%, var(--wood-mid) 60%, var(--wood-light) 100%)',
              position:'relative', overflow:'hidden', display:'flex', alignItems:'flex-end', padding:'40px'
            }}>
              <div style={{fontFamily:"'Playfair Display', serif", fontSize:'64px', color:'rgba(245,239,230,0.1)', fontWeight:700, lineHeight:1}}>
                SINCE<br />2010
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
<div className="stats-bar" style={{gridTemplateColumns:'repeat(3,1fr)'}}>
  <div><div className="stat-num">15+</div><div className="stat-label">Yıllık Deneyim</div></div>
  <div><div className="stat-num">1.200+</div><div className="stat-label">Tamamlanan Proje</div></div>
  <div><div className="stat-num">10+</div><div className="stat-label">Ülkeye İhracat</div></div>
</div>

      {/* DEĞERLERİMİZ */}
      <section className="section about-bg">
        <div className="section-tag">Değerlerimiz</div>
        <div className="section-title">Bizi Biz Yapan İlkeler</div>
        <div className="values-grid">
          {values.map((v, i) => (
            <div className="value-card" key={i}>
              <div className="value-icon">{v.icon}</div>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </section>



      {/* CTA */}
      <section className="testimonial">
        <div className="testimonial-inner">
          <div className="quote-mark">"</div>
          <p className="testimonial-text">Her ahşap parça bir hikaye taşır. Biz o hikayeleri yaşam alanlarınıza aktarıyoruz.</p>
          <div className="testimonial-author">ÖZGÜR YILDIRIM · Element Global Kurucusu</div>
          <div style={{marginTop:'40px'}}>
            <Link to="/iletisim" className="btn-primary">Projenizi Konuşalım</Link>
          </div>
        </div>
      </section>
    </>
  );
}
